export function getSeasonalOverrideThemeId(now) {
  const date = now || new Date();

  const month = date.getMonth(); // 0-indexed
  const day = date.getDate();

  // November = 10 (0 indexed)
  const isNovember = month === 10;

  if (!isNovember) return null;

  // Active window: Nov 5 - Nov 12 inclusive
  if (day >= 5 && day <= 12) {
    return "remembrance";
  }

  return null;
}
